import { Component, OnInit, Inject , OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import * as fileSaver from 'file-saver';
import * as JSZip from 'jszip';
import { FileDataService } from '../services/file-data.service';
import { SPLIT_WAYPOINT_OPTIONS } from '../../constants';
import { AuthService } from 'src/app/user/services/auth.service';
import { Router } from '@angular/router';

//Interface / Enum's
import { IFileExtension, ICSVConfig } from './file-import';
import { IWayPoint } from '../itinenary-list/itinerary';
import { IItineraryRoute } from '../itinerary-route/itinerary-route';

//Dialogs
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { CsvConfigDialog } from './csv-config/csv-config.dialog';
import { SaveAsDialog } from './save-as/save-as.dialog';
import { TrackTypeDialog } from './track-type/track-type.dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { EventListenerFocusTrapInertStrategy } from '@angular/cdk/a11y';
import { file } from 'jszip';

@Component({
  selector: "app-file-export",
  templateUrl: "./file-export.save.locally.component.html",
  styleUrls: ["./file-export.save.locally.component.scss"],
})
export class FileExportSaveLocallyComponent implements OnInit, OnDestroy {
  @ViewChild("fileImport") fileImport: ElementRef;
  fileResponseData = null;
  currentFileName: string = '';
  // Default .itn File save  //
  selectedFileExportFormat: IFileExtension = {
    name: "TomTom Itinerary (.itn)",
    primaryFormat: ".itn",
    extension: [".itn"],
    isLink: false,
  };
  // selectedFileExportFormat: IFileExtension = {
  //   name: "Sygic GPS Navigation 13 - 17 (.itf)",
  //   primaryFormat: ".itf",
  //   extension: [".itf"],
  //   isLink: false,
  // };
  fileExportFormatList: IFileExtension[] = [];
  isCSV: boolean = false;
  csvData: ICSVConfig;

  // Subscription List
  subs: Subscription[] = [];
  // Waypoints displayed in ITINENARY TABLE (Always stores current data)
  displayedWaypoints: IWayPoint[] = [];
  url: string;

  //Itinerary-Route related variables
  isItineraryRoute: boolean = false;
  itineraryRouteData = [];

  splitWaypointList = SPLIT_WAYPOINT_OPTIONS;
  selectedSplitWaypoint: any = SPLIT_WAYPOINT_OPTIONS[0];
  filename:any[]=[];
  userid:string='';
  reloadFiledata:any;
  currentItnName: string = '';
  file:any
  constructor(
    public dialogRef: MatDialogRef<FileExportSaveLocallyComponent>,
    private fileService: FileDataService,
    private csvDialog: MatDialog,
    private confirmDialog: MatDialog,
    private snackBar: MatSnackBar,
    private authService: AuthService, 
    private router: Router    
  ) { }
  

  ngOnInit() {
      
     this.fileService.getFileExtensions().subscribe(
      (res: any) => {
        if (res.responseStatus === "Success") {
          this.fileExportFormatList = res.responseData;
        } else if (res.responseCode != null && res.responseCode.statusCode === 401) {
          this.authService.logout();
          this.dialogRef.close();
          this.router.navigate(['/user/login']);
        }
      },
      (err) => console.log("Error while fetching file extensions: ", err)
    );

    // Watch for changes when ITNENARY TABLE is modified
    this.subs.push(this.fileService.currentItinenary$.subscribe(
      (waypoints) => {
        this.displayedWaypoints = waypoints;
      }
    ));
    // Watch for changes if itineraryRoute to be fetched 
    this.subs.push(this.fileService.isFetchRoute$.subscribe(
      (isRoute: boolean) => {
        this.isItineraryRoute = isRoute;
        // Trigger FILE IMPORT 
        if (this.isItineraryRoute) {
          this.fileImport.nativeElement.click();
        }
      }
    ));
    this.subs.push(this.fileService.currentItineraryRouteData$.subscribe(
      (routeData: IItineraryRoute[]) => {
        this.itineraryRouteData = routeData;
      }
    ));
    
this.subs.push(
this.fileService.currentItineraryName$.subscribe(
    (name: string) => {​​​​​​​​
     if (name) {​​​​​​​​
      var fileUserName=name.split("_");
      if(this.fileService.currentUserName.firstName == fileUserName[0]){​​​​​​​​
         var userFileRemove="";
         fileUserName.forEach(element=> {​​​​​​​​
         if(this.fileService.currentUserName.firstName!=element)
          userFileRemove=userFileRemove+element+"_";
              }​​​​​​​​);
           this.currentFileName = userFileRemove.substring(0, userFileRemove.length - 1);
            }​​​​​​​​
          else{​​​​​​​​
            this.currentFileName=name;
            }​​​​​​​​
          }​​​​​​​​
        }​​​​​​​​)
    )



       
  }
  compareWithFileExtension(
    extension1: IFileExtension,
    extension2: IFileExtension
  ) {
    return extension1.name === extension2.name;
  }

  getFileDetails(event: any): void {
    this.fileService.isFitSelectRoute = true;
    const file: File = (event.target === undefined) ? event.valueOf(FileList)[0] : event.target.files[0];
    //#bug : empty the target value so that same filename can be imported twice
    if (event.target !== undefined) event.target.value = "";
    // CSV File Format Check
    this.isCSV = file && file.name.split(".")[1] === "csv" ? true : false;
    if (this.isCSV) {
      this.csvImportExport("Import").then(
        (res) => {
          this.csvData = res;
          this.uploadFileData(file);
        },
        (err) => {
          console.log("Unable to write CSV File");
        }
      );
    } else {
      this.uploadFileData(file);
    }
  }

  /**
   * Sends the file from browser to Server
   * Shares the parsed file data(recieved from backend) to fileService
   * @param files - File[]
   */
  uploadFileData(file: File): void {
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);

    if (this.isCSV) {
      formData.append("csvSetting", JSON.stringify(this.csvData));
    }

    this.fileService.uploadFile(formData).subscribe(
      (res: any) => {
        if (res.responseStatus === "Success" &&
          res.responseData && (res.responseData.containsPolygon || res.responseData.containsRoute)
        ) {
          if (res.responseData.containsPolygon && res.responseData.containsRoute) {
            this.openDialog(res);
          } else {
            const type = res.responseData.containsPolygon ? 'polygon' : 'route';
            this.handleFileImportData(res, type);
          }
        } else {
          const errorMessage = res.responseMessage || 'Unable to parse the file';
          this.openSnackBar(errorMessage);
        }
      },
      (error) => console.log("Error while Uploading file: ", error)
    );
  }

  openDialog(res: any) {
    const fileName: string = this.currentFileName || 'Itinerary';
    const trackTypeDialog = this.csvDialog.open(TrackTypeDialog, {
      width: "30rem",
      disableClose: true,
    });

    trackTypeDialog.afterClosed().subscribe((result) => {
      if (result.saveData) {
        this.handleFileImportData(res, result.response.typeOptions);
      }
    });
  }

  handleFileImportData(res: any, type: string) {

    // Send data to `ITINERARY TABLE`
    if (!this.isItineraryRoute) {
      this.changeItineraryName(res.responseData.fileName);
      this.fileResponseData = res.responseData;
      const { wayPoints, polygonPoints } = this.fileResponseData;
      if (type === 'route' && (wayPoints || polygonPoints)) {
        this.fileService.changeItinenaryData(wayPoints, false);
      } else {
        this.fileService.changeItinenaryData(polygonPoints, false);
      }
      this.fileService.isDrawPolygon = (type === 'polygon' ? true : false);
    } else {
      // Send data to `ITINERARY ROUTE LIST`
      let wayPointsOrPolygonPoints: IWayPoint[];
      if (type === 'polygon') {
        if (res.responseData.containsPolygon && res.responseData.containsMultiPolyLine) {
          wayPointsOrPolygonPoints = res.responseData.multiRoute;
        } else {
          wayPointsOrPolygonPoints = res.responseData.polygonPoints;
        }
      } else {
        wayPointsOrPolygonPoints = res.responseData.wayPoints;
      }

      const routeData: IItineraryRoute = {
        id: this.itineraryRouteData.length > 0 ? this.itineraryRouteData.length + 1 : 1,
        name: res.responseData.fileName,
        isPolygon: res.responseData.containsPolygon,
        multiRoute: res.responseData.containsMultiPolyLine,
        waypoints: wayPointsOrPolygonPoints
      };
      this.itineraryRouteData.push(routeData);
      this.fileService.changeItineraryRouteData(this.itineraryRouteData);
      this.fileService.addItineraryRoute(false);
    }
  }
  cancel(): void {
    this.dialogRef.close();
  }
  getExportSaveLocallyFileData(): void {
    const fileName: string = this.currentFileName || 'Itinerary';   
    if (this.selectedFileExportFormat.primaryFormat === ".csv") {
      this.csvImportExport("Export").then(
        (res) => {
          this.isCSV = true;
          this.csvData = res;
          this.dialogRef.close({
          });
          const existName=fileName+".csv";
          this.exportFile(existName, this.selectedFileExportFormat.primaryFormat);
        },
        (err) => {
          console.log("Unable to write CSV File");
        }
      );
    } else {
      this.isCSV = false;
      this.dialogRef.close({
      });
      const existName=fileName+this.selectedFileExportFormat.primaryFormat;
    //   const filterExistName=this.filename.filter(b=>b.name===existName)[0];
    //   if(existName){
    //   this.fileService.DeleteFiles(existName).subscribe((data:any)=>{
    //     if(data.responseData==null){
    //     this.exportFile(existName, this.selectedFileExportFormat.extension[0]);
    //     }
    //   })
    // }
    this.exportFile(existName,this.selectedFileExportFormat.primaryFormat)
     
    }
  } 


 openFileSaveAsDialog() {
    const fileName: string = this.currentFileName || 'Itinerary';
    if (!this.selectedFileExportFormat.isLink) {
      const saveAsdialog = this.csvDialog.open(SaveAsDialog, {
        width: "30rem",
        disableClose: true,
        data: {
          fileName: `${fileName}${this.selectedFileExportFormat.primaryFormat}`,
          selectedFormat: this.selectedFileExportFormat,
        },
      });

      saveAsdialog.afterClosed().subscribe((result) => {
        //Save the data if ONLY some data is passed via SaveAs Dialog
        if (result.saveData) {
          const { exportFileName, fileExtension } = result.response;
          this.exportFile(exportFileName, fileExtension);
        }
      });
    } else {
      var name=this.filename.filter(b=>b.name===fileName);
    if(fileName=="Itinerary"){
      var name=[];
      name= this.filename.filter(b=>b.name===fileName);
      for(let value of name){
      var existsname=value.name+this.selectedFileExportFormat.primaryFormat     
        // this.fileService.DeleteFiles(existsname).subscribe((data:any)=>{
         
        // })
      
      }
    }
    else{
    name= this.filename.filter(b=>b.name===fileName)
    for(let value of name){
    var existsname=value.name+this.selectedFileExportFormat.primaryFormat;
    // if(existsname){
    //   this.fileService.DeleteFiles(existsname).subscribe((data:any)=>{        
    //   })
    // }
   }
  }
      this.exportFile(fileName, this.selectedFileExportFormat.primaryFormat);
    }
  }

  /** 
   * Export the file with selected format
   */
  exportFile(fileName: string, extension: string): void {
    const payload = { ...this.fileResponseData };
    payload.exportTo = this.selectedFileExportFormat.name;
    payload.fileExtension = extension;
    payload.wayPoints = this.displayedWaypoints;
    payload.fileName = fileName.split(".")[0]; // Send fileName and extension in separate field
    payload.splitWayPointsBy = this.selectedSplitWaypoint.value;
    
    if (this.isCSV && this.csvData) {
      payload.csvFileSetting = this.csvData;
      payload.isCsv = true;
    }

    const exportedData = this.fileService.exportItinerary(payload) ;
    if (exportedData != null) {
      this.generateAndDownloadFile(exportedData);
      this.fileService.isItinerayChanged = false;
      console.log("File downloaded successfully");
    }
  }

  generateAndDownloadFile(res: any) {
    const { multiFileContent, type, url, fileExtension, itfFileContent } = res;
    var zip = new JSZip();
    // Download the file based on 'type'
    //if (type === "File") {
      for (const fileItem in multiFileContent) {
        const bytes = fileExtension === '.itf' ? this.byteArrayConversion(itfFileContent) : multiFileContent[fileItem];
        const blob: any = new Blob([bytes], {
          type: "application/octet-stream",
        });
        this.file = new File([blob], `${fileItem}${fileExtension}`, {
          type: "application/octet-stream",
        });
        fileSaver.saveAs(this.file)
      // zip.file(`${fileItem}${fileExtension}`,blob);                               
     }
  }

  /**
   * Byte Array conversion wrt ITF file
   * @param fileContent 
   */
  byteArrayConversion(fileContent: string) {
    const binaryString = window.atob(fileContent);
    const binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  /**
   * Open CSV Config dialog
   * Fetch User defined CSV config data
   * @param mode - Import or Export
   */
  async csvImportExport(mode: string): Promise<ICSVConfig> {
    return new Promise<ICSVConfig>((resolve, reject) => {
      const dialogRef = this.csvDialog.open(CsvConfigDialog, {
        width: "30rem",
        disableClose: true,
        data: mode,
      });

      dialogRef.afterClosed().subscribe((result) => {
        //Save the data if ONLY some data is passed via crudDialog
        if (result.saveData) {
          resolve(result.csvData);
        } else {
          reject();
        }
      });
    });
  }
  checkModifiedData() {
    if (this.displayedWaypoints.length) {
      const message =
        "Changes will be lost. Continue anyway?";
      const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
        width: "28rem",
        data: message,
        disableClose: false,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.saveData) {
          this.fileService.isSelectedMarker=true;
          this.fileService.isDisableUTurn = false;
          this.fileImport.nativeElement.click();
        }
      });
    } else {
      this.fileImport.nativeElement.click();
    }
    
  }
  openSnackBar(message: string) {
    this.snackBar.open(message, 'close', {
      duration: 10000,
      verticalPosition: 'top'
    });
  }
  /**
   * Helper function to update the current `ITINERARY NAME` 
   * in both places(export section and ITN table)
   */
  changeItineraryName(name: string) {
    this.currentFileName = name;
    this.fileService.changeItineraryName(name);
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
    this.currentFileName=null;
    this.selectedFileExportFormat.primaryFormat=null;
    
  }
}

export class ExportFileData {
  fileName: string;
  fileExtension: string;
  type: string;
  url: string;
  contentGenerated: boolean;
  multiFileContent: { [key: string]: string };
  itfFileContent: Uint8Array;
constructor() {
      this.fileName = '';
      this.fileExtension = '';
      this.type = '';
      this.url = '';
      this.contentGenerated = false;
      this.multiFileContent = {};
      this.itfFileContent = new Uint8Array();
  }
}

export class Itinerary {
  fileName: string;
  fileExtension: string;
  fileSize: number;
  exportTo: string;
  exportType: string;
  wayPoints: WayPoint[];
  polygonPoints: WayPoint[];
  internalFileName: string;
  isCsv: boolean;
  containsPolygon: boolean;
  containsMultiPolyLine: boolean;
  polygonName: string;
  containsRoute: boolean;
  routeName: string;
  csvFileSetting: any; // Replace with appropriate type if you have a class for CsvSetting
  splitWayPointsBy: number | null;
  multiRoute: WayPoint[][];
  splitedRouteWayPoints: WayPoint[][];
constructor() {
      this.fileName = '';
      this.fileExtension = '';
      this.fileSize = 0;
      this.exportType = 'File';
      this.wayPoints = [];
      this.polygonPoints = [];
      this.internalFileName = '';
      this.isCsv = false;
      this.containsPolygon = false;
      this.containsMultiPolyLine = false;
      this.containsRoute = true;
      this.polygonName = '';
      this.routeName = '';
      this.csvFileSetting = {};
      this.splitWayPointsBy = null;
      this.multiRoute = [];
      this.splitedRouteWayPoints = [];
  }
}

export class WayPoint {
  id: number;
  itineraryName: string;
  latitude: string;
  longitude: string;
  latitudeDD: string;
  longitudeDD: string;
  latitudeDM: string;
  longitudeDM: string;
  latitudeDMS: string;
  longitudeDMS: string;
  elevation: string;
  comment: string;
  sequenceId: number;
  selectedCoordinate: any; // Replace with appropriate type if needed
constructor() {
      this.id = 0;
      this.itineraryName = '';
      this.latitude = '';
      this.longitude = '';
      this.elevation = '0';
      this.comment = '';
      this.sequenceId = 0;
      this.selectedCoordinate = {};
  }
}

